module.exports = __webpack_public_path__ + "static/media/course-orientation.2dd66c3c.jpg";